/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
/* eslint-disable security/detect-object-injection */
// @ts-nocheck
import './services/maintenance';
import Vue from 'vue';
import App from './App.vue';
// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
// axios
import axios from './services/axios.js';
// Filters
import './filters/filters.js';
// Theme Configurations
import '../themeConfig.js';
// Globally Registered Components
import './globalComponents.js';
// Styles: SCSS
import './assets/scss/main.scss';
// Tailwind
import '@/assets/css/main.css';
// Vue Router
import router from './router/router';
// Vuex Store
import store from './store/store';
// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer';
//Vue Moment
// i18n
import i18n from './lang/i18n';
// PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
//VueLogger
import VueLogger from 'vuejs-logger';
import loggerOptions from './services/logger';
//VeeValidate
import VeeValidate, {Validator} from 'vee-validate';
import fr from 'vee-validate/dist/locale/fr';
import en from 'vee-validate/dist/locale/en';

//MDI
import '@mdi/font/css/materialdesignicons.css';

//Cognito
import Amplify from '@aws-amplify/core';

import VueApexCharts from 'vue-apexcharts';
import './services/hal-client-config';
import {createClient, ResourceImpl} from 'hal-client';
//import Vuetify from 'vuetify';

Vue.use(VeeValidate);
Validator.localize('fr', fr);
Validator.localize('en', en);

Amplify.configure({
  Auth: {
    region: process.env.VUE_APP_COGNITO_REGION,
    userPoolId: process.env.VUE_APP_COGNITO_USER_POOL,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
    oauth: {
      domain: process.env.VUE_APP_COGNITO_IDP_DOMAIN,
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: process.env.VUE_APP_COGNITO_IDP_SIGN_IN,
      redirectSignOut: process.env.VUE_APP_COGNITO_IDP_SIGN_OUT,
      responseType: 'code'
    }
  }
});

Vue.use(Vuesax);
//Vue.use(Vuetify);
Vue.prototype.$http = axios;

Vue.use(VueHammer);

Vue.use(VueLogger, loggerOptions);

const moment = require('moment');
require('moment/locale/fr');
moment.locale('en');
Vue.use(require('vue-moment'), {
  moment
});

// Feather font icon
require('./assets/css/iconfont.css');

//Apex charts
Vue.use(VueApexCharts);
Vue.component('vue-apex-charts', VueApexCharts);

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

Vue.filter('prettyBytes', function (num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number');
  }

  const neg = num < 0;
  const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return `${(neg ? '-' : '') + num} B`;
  }

  const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  const unit = units[exponent];
  return `${neg ? '-' : ''}${num} ${unit}`;
});


Vue.filter('durationFormat', (period) => {
  const parts = [];
  const duration = moment.duration(period);

  if (!duration) return i18n.t('common.constants.durations.none');

  if (!duration || duration.toISOString() === 'P0D') return `0 ${i18n.t('common.constants.durations.seconds.single')}`;

  if (duration.years() >= 1) {
    const years = Math.floor(duration.years());
    parts.push(`${years} ${years > 1 ? i18n.t('common.constants.durations.years.multiple') : i18n.t('common.constants.durations.years.single')}`);
  }

  if (duration.months() >= 1) {
    const months = Math.floor(duration.months());
    parts.push(`${months} ${months > 1 ? i18n.t('common.constants.durations.months.multiple') : i18n.t('common.constants.durations.months.single')}`);
  }

  if (duration.days() >= 1) {
    const days = Math.floor(duration.days());
    parts.push(`${days} ${days > 1 ? i18n.t('common.constants.durations.days.multiple') : i18n.t('common.constants.durations.days.single')}`);
  }

  if (duration.hours() >= 1) {
    const hours = Math.floor(duration.hours());
    parts.push(`${hours} ${hours > 1 ? i18n.t('common.constants.durations.hours.multiple') : i18n.t('common.constants.durations.hours.single')}`);
  }

  if (duration.minutes() >= 1) {
    const minutes = Math.floor(duration.minutes());
    parts.push(`${minutes} ${minutes > 1 ? i18n.t('common.constants.durations.minutes.multiple') : i18n.t('common.constants.durations.minutes.single')}`);
  }

  if (duration.seconds() >= 1) {
    const seconds = Math.floor(duration.seconds());
    parts.push(`${seconds} ${seconds > 1 ? i18n.t('common.constants.durations.seconds.multiple') : i18n.t('common.constants.durations.seconds.single')}`);
  }

  return `${parts.join(', ')}`;
});

fetch(process.env.VUE_APP_ROOT_API, {
  mode: 'cors',
  cache: 'no-cache',
  credentials: 'include',
  headers: {
    accept: 'application/hal+json'
  }
})
  .then(response => {
    if (response.status === 503) {
      throw new Error();
    }
    return response.json();
  })
  .then(async () => {
    const apiRoot = await createClient(process.env.VUE_APP_ROOT_API);
    store.commit('router/updateRouteProp', {
      property: 'apiRoot',
      value: apiRoot
    });
    new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app');
  }, () => {
    store.commit('router/updateRouteProp', {
      property: 'apiRoot',
      value: new ResourceImpl({}, '')
    });
    if (window.location.pathname !== '/maintenance') {
      window.location.pathname = '/maintenance';
    }
    new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app');
  });

